import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { tpoGenUrls } from 'config/urls';
import { tpoGenKeys } from '../../../../utils/tpoGenQueryKeys';

export interface ApiConstraintLevelDetail {
    attribute_name: string;
    original_value: number | null;
    default_value: number | null;
    full_year_original_value?: number | null;
    constraint: { min: number; max: number } | null;
}

export interface ApiConstraintDetails {
    constraint_name: string;
    label: string;
    constraint_type: 'range';
    level_details: ApiConstraintLevelDetail[];
    objective_constraint?: boolean;
}

export interface ConstraintsDataResponse {
    constraint_details: ApiConstraintDetails[];
}

const fetchConstraintsData = async (
    payload: Record<string, unknown>,
    signal?: AbortSignal,
): Promise<{ data: ConstraintsDataResponse }> => {
    const response = await axios(tpoGenUrls.getConstraintsListOriginalValues, {
        method: 'POST',
        data: payload,
        signal,
    });
    return response.data;
};

const useConstraintsData = ({
    payload,
    enabled,
}: {
    payload: Record<string, unknown> | null;
    enabled: boolean;
}) => {
    const { data, isLoading, isError } = useQuery({
        queryKey: tpoGenKeys.optimizationValues(payload),
        queryFn: ({ signal }) => fetchConstraintsData(payload!, signal),
        enabled: enabled && Boolean(payload),
        refetchOnWindowFocus: false,
    });

    return {
        constraintsData: data ?? null,
        constraintsLoading: isLoading,
        constraintsError: isError,
    };
};

export default useConstraintsData;
